module.exports = __webpack_public_path__ + "static/media/cisconetworking.f6d7e345.png";